import React, { ReactNode, MouseEvent } from 'react';
import styled from '@emotion/styled';
import { Flex, Box } from 'reflexbox';

import { LinkProps } from '../../../../../containers/Link/types';
import { MARKETING_PAGE_BREAKPOINT_DESKTOP } from '../../../../Style/breakpoints';
import { RouteLink } from '../../../../RouteLink/component';

const Container = styled(Flex)``;

const Header = styled.div`
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-weight: 900;
  font-size: 26px;
  line-height: 120%;
  letter-spacing: -0.01em;
  color: #041416;
  padding: 12px 0;
`;

const Description = styled.div`
  font-family: Avenir, sans-serif;
  font-style: normal;
  font-weight: normal;
  font-size: 16px;
  line-height: 140%;
  color: #3e4b4c;
  padding: 12px 0;
`;

const Desktop = styled(Box)`
  display: none;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    display: block;
  }
`;

const Mobile = styled(Box)`
  display: block;
  @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
    display: none;
  }
`;

export const CourseTypeItem = React.memo(
  ({
    icon,
    header,
    description,
    link,
    onClick,
  }: {
    icon: ReactNode;
    header: string;
    description: string;
    link: LinkProps;
    onClick: (e: MouseEvent) => void;
  }) => {
    const NavLink = styled(RouteLink)`
      color: #3e4b4c;
      padding: 6px;
      display: block;
      float: none;
      font-family: Avenir, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      text-decoration: none;
      line-height: 100%;
      cursor: pointer;
      :hover {
        opacity: 0.9;
      }
      @media only screen and (min-width: ${MARKETING_PAGE_BREAKPOINT_DESKTOP}) {
        font-family: Avenir, sans-serif;
        font-style: normal;
        font-weight: 800;
        font-size: 16px;
        line-height: 140%;
        text-decoration: none;
        color: #cf1b53;
        &:hover {
          opacity: 0.9;
        }
      }
    `;

    return (
      <Container>
        <Desktop>
          <Flex padding={24}>
            <Box minWidth={100} marginTop={12}>
              {icon}
            </Box>
            <Flex flexDirection="column">
              <Header>{header}</Header>
              <Description>{description}</Description>
              <NavLink
                key={`subnav-item-${header}`}
                to={link.to}
                onClick={onClick}
              >
                {link.title}
              </NavLink>
            </Flex>
          </Flex>
        </Desktop>
        <Mobile>
          <NavLink key={`subnav-item-${header}`} to={link.to}>
            {header}
          </NavLink>
        </Mobile>
      </Container>
    );
  }
);
